import { lazy } from 'react';

// project import
import MainLayout from '../layout/MainLayout';
import CommonLayout from '../layout/CommonLayout';
import Loadable from '../components/Loadable';
import AuthGuard from '../utils/route-guard/AuthGuard';
import { connectionRoutes } from './ConnectionRoutes';
import { settingsRoutes } from './SettingsRoutes/SettingsRoutes';
import { RouteObject } from 'react-router';
import { JourneyDetailLayout } from '../journey/JourneyDetailLayout';
import { PersonaDetailPage } from '../persona/detail/PersonaDetailPage';
import { SettingsLayout } from '../settings/SettingsLayout';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('../pages/maintenance/404')));

// render - sample page
const DashboardPage = Loadable(lazy(() => import('../dashboard/DashboardPage')));
const JourneyListPage = Loadable(lazy(() => import('../journey/list/JourneyListPage')));
const JourneyDetailPage = Loadable(lazy(() => import('../journey/detail/JourneyDetailPage')));
const JourneySubactivityPage = Loadable(lazy(() => import('../journey/subactivity/JourneySubactivityPage')));
const JourneyWarningsPage = Loadable(lazy(() => import('../journey/warnings/JourneyWarningsPage')));
const JourneyTimelinePage = Loadable(lazy(() => import('../journey/timeline/JourneyTimelinePage')));
const JourneyPlanningPage = Loadable(lazy(() => import('../journey/planning/JourneyPlanningPage')));
const PersonaListPage = Loadable(lazy(() => import('../persona/PersonaListPage')));
const OpportunityListPage = Loadable(lazy(() => import('../opportunities/list/OpportunityListPage')));
const OpportunityDetailPage = Loadable(lazy(() => import('../opportunities/detail/OpportunityDetailPage')));
const ActionListPage = Loadable(lazy(() => import('../actions/list/ActionListPage')));
const ActionDetailPage = Loadable(lazy(() => import('../actions/detail/ActionDetailPage')));
//TODO: Uncomment when Competence will be ready
//const CompetencePage = Loadable(lazy(() => import('pages/main/CompetencePage')));
const ConnectionsLayout = Loadable(lazy(() => import('../connections/ConnectionsLayout')));
const UpgradePlanPage = Loadable(lazy(() => import('../upgrade-plan/UpgradePlanPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes: RouteObject = {
	path: '/',
	children: [
		{
			path: '/',
			element: (
				<AuthGuard>
					<MainLayout />
				</AuthGuard>
			),
			children: [
				{
					path: '/dashboard',
					element: <DashboardPage />,
				},
				{
					path: '/journeys',
					element: <JourneyListPage />,
				},
				{
					path: 'journeys/:id',
					element: <JourneyDetailLayout />,
					children: [
						{
							path: 'activity-map',
							element: <JourneyTimelinePage />,
						},
						{
							path: 'detail',
							element: <JourneyDetailPage />,
							children: [
								{
									path: 'subactivity/:subactivityId',
									element: <JourneySubactivityPage />,
								},
							],
						},
						{
							path: 'warnings',
							element: <JourneyWarningsPage />,
						},
						{
							path: 'planning',
							element: <JourneyPlanningPage />,
						},
					],
				},
				{
					path: '/expired',
					element: <UpgradePlanPage />,
				},
				{
					path: '/personas',
					element: <PersonaListPage />,
				},
				{
					path: 'personas/:id',
					element: <PersonaDetailPage />,
					children: [
						{
							path: 'detail',
							element: <PersonaDetailPage />,
						},
					],
				},
				{
					path: '/opportunities',
					element: <OpportunityListPage />,
				},
				{
					path: '/opportunities/:id/detail',
					element: <OpportunityDetailPage />,
				},
				{
					path: '/actions',
					element: <ActionListPage />,
				},
				{
					path: '/actions/:id/detail',
					element: <ActionDetailPage />,
				},
				//TODO: Uncomment when Competence will be ready
				/* {
					path: '/competence',
					element: <CompetencePage />,
				}, */
				{
					path: '/connections',
					element: <ConnectionsLayout />,
					children: connectionRoutes,
				},
				{
					path: '/settings',
					element: <SettingsLayout />,
					children: settingsRoutes,
				},
			],
		},
		{
			path: '/maintenance',
			element: <CommonLayout />,
			children: [
				{
					path: '404',
					element: <MaintenanceError />,
				},
			],
		},
	],
};

export default MainRoutes;
